import React from 'react';

import {Button, Col, Radio, Row, Spin} from 'antd';
import './OriginatorDetailsPanel.css';
import FieldValueVerticalCell from 'components/general/FieldValueVerticalCell';

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import Divider from "antd/es/divider";
import RadioGroup from "antd/lib/radio/group";
import {getVirtualAccountBalanceByVirtualAccId} from "../api/api";
import {displayError} from "../common/notifications";
import {displayNumberWithComma} from "../utils/utils";


class OriginatorDetailsPanel extends React.Component {

    state={
        selectedVaId:null
    }

    onAccountSelected = val => {
        this.props.onSelectOrigVa(val, this.props.originator.id);
    }

    selectedVaId = (vaId) =>{
        let selectedVaId = this.state.selectedVaId;
        this.setState({
            selectedVaId:vaId
        })
        getVirtualAccountBalanceByVirtualAccId(vaId,false).then(res =>{
            const intl = this.props.useIntl;
            let originator = this.props.originator;
            let virtualAccounts = originator.virtualAccounts;
            if(virtualAccounts) {
                virtualAccounts.forEach(item=>{
                    if(res.balance) {
                        if (item.id === vaId) {
                            item.vaBalanceStr = res.balance;
                            item.vaBalanceStrClaimed = res.claimedBalance;
                        }
                    }else {
                        item.vaBalanceStr=[];
                        item.vaBalanceStrClaimed=[];
                    }
                })
            }
            this.props.updateOriginator (this.props.idxOfCurrentItem,originator);
            this.setState({
                selectedVaId:null
            })

        }).catch(e=>{
            displayError(JSON.stringify(e));
            this.setState({
                selectedVaId:null
            })
        })
    }

    buildVaBalanceInfo = (id,virtualAccountNumber,vaBalanceStr, vaBalanceTitle) => {
        const intl = this.props.useIntl;
        if (!virtualAccountNumber) {
            return null;
        }
        let result = '';
        if (vaBalanceStr) {
            if(this.props.sourceCurrency in vaBalanceStr) {
                let bal = vaBalanceStr[this.props.sourceCurrency];
                if(bal && !isNaN(bal)) {
                    result = this.props.sourceCurrency + " " + displayNumberWithComma(bal);
                }

                if (result.length == 0) {
                    result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
                }
            }

            return (
                <FieldValueVerticalCell
                    style={{whiteSpace: "pre-line"}}
                    className="bp-table-cell"
                    title={vaBalanceTitle}
                    value={result}
                />
            );
        } else {
            if (this.state.selectedVaId === id) {
                return <Spin/>;
            } else {
                return (
                    <>
                        <FieldValueVerticalCell
                            style={{whiteSpace: "pre-line"}}
                            className="bp-table-cell"
                            title={vaBalanceTitle}
                            value={'-'}
                        />
                    </>
                );
            }
        }
    }



    render() {
        const intl = this.props.useIntl;
        return (
            <>
            <div className="originator-details">
                <Row>
                    <Col md={6} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.nameofsender"})} value={this.props.originator.displayName} />
                    </Col>

                    <Col md={8} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.sendertype"})} value={this.props.originator.originatorType}/>
                    </Col>

                    <Col md={5} sm={12}>
                        <FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.sourceoffunds"})} value={this.props.originator.sourceOfFunds} />
                    </Col>
                    <Col md={5} sm={12}>
                        <FieldValueVerticalCell
                            title={intl.formatMessage({id: "app.panel.originatordetailspanel.referencenumber"})}
                            value={this.props.originator.referenceNumber}/>
                    </Col>
                </Row>

                {this.props.originator.virtualAccounts && this.props.originator.virtualAccounts.length > 0 && (
                    <>
                        <Divider />
                        <RadioGroup style={{width:"100%"}} onChange={event => this.onAccountSelected(event.target.value)} value={this.props.selectedOriginatorVAId}>

                            {this.props.originator.virtualAccounts.map(item => {

                                let location = '';
                                if (item.virtualAccountChannelCode == 'DBS_HK') {
                                    location = "Hong Kong"
                                } else if (item.virtualAccountChannelCode == 'DBS_SG') {
                                    location = "Singapore"
                                } else if (item.virtualAccountChannelCode == 'SAHABAT_SAMPOERNA') {
                                    location = "Indonesia"
                                } else if (item.virtualAccountChannelCode == 'FLASH_FX') {
                                    location = "Australia"
                                }

                                let disabledVa = this.props.disabledOrig;
                                if(!item.virtualAccountNumber) {
                                    disabledVa = true;
                                }else {
                                    if (!item.currencies || !item.currencies.includes(this.props.sourceCurrency)) {
                                        disabledVa = true;
                                    }
                                }

                                return (
                                    <>
                                        <Row style={{marginTop: "0"}}>
                                            <Col md={2} sm={12} style={{paddingTop: "2px", paddingLeft: "12px"}}>
                                                <Radio disabled={disabledVa} value={item.id} checked={this.props.selectedOriginatorVAId === item.id}
                                                    onChange={()=>{
                                                        this.selectedVaId(item.id);
                                                    }}
                                                >
                                                </Radio>
                                            </Col>
                                            <Col md={4} sm={12}><FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.valocation"})} value={location}/></Col>
                                            <Col md={4} sm={12}><FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.vaname"})} value={item.virtualAccountName}/></Col>
                                            <Col md={6} sm={12}><FieldValueVerticalCell title={intl.formatMessage({id: "app.panel.originatordetailspanel.vanumber"})} value={item.virtualAccountNumber}/></Col>
                                            <Col md={4} sm={12}>
                                                {this.buildVaBalanceInfo(item.id,item.virtualAccountNumber,item.vaBalanceStr, intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"}))}
                                            </Col>
                                            <Col md={4} sm={12}>
                                                {this.buildVaBalanceInfo(item.id,item.virtualAccountNumber,item.vaBalanceStrClaimed, intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"}))}
                                            </Col>

                                        </Row>
                                        
                                        <Divider />
                                    </>
                                );
                            })}
                        </RadioGroup>
                    </>
                )}
            </div>
                </>
        )
    }
}

export default withUseIntl(OriginatorDetailsPanel);